import axios from 'axios';
import heic2any from 'heic2any';

export const getImage = async (imageKey) => {
  try {
    const response = await axios.get(`/images/${imageKey}`, {
      responseType: 'blob'
    });

    // Convert the blob to a data URL
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    try {
      const result = await heic2any({ blob, toType: 'image/jpeg', quality: 0.8 });
      const jpegBlob = Array.isArray(result) ? result[0] : result;
      return URL.createObjectURL(jpegBlob);
    } catch (err) {
      return URL.createObjectURL(blob);
    }
  } catch (error) {
    console.error('Error fetching image:', error);
  }
};

export const arrayBufferToBase64 = (buffer) => {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
};

/**
 *
 * @param {string} url
 * @param {formData} file
 * @returns response.data
 */
export const uploadImage = async (url, file) => {
  const res = await axios({
    url: url,
    method: 'POST',
    data: file,
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  return res.data;
};
